import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import DxDiagnosisResultForm from '@src/features/tenant/dxDiagnosis/DxDiagnosisResultForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function DxDiagnosisResults() {
  return (
    <TenantRoleGuard
      canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT]}
      canService={[SERVICE.DX_DIAGNOSIS]}
    >
      <TenantDefaultLayout>
        <CommonHelmet />
        <DxDiagnosisResultForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default DxDiagnosisResults;
